const explodeTime = (time) => {
  const [hour, minute, second, millisecond] = time
    .split(/:|\./)
    .map((t) => parseInt(t));

  return { hour, minute, second, millisecond };
};

export default explodeTime;



// WEBPACK FOOTER //
// ./src/helpers/explodeTime.js